import { NotesPanelTab } from '../../helpers/notesPanel'
import Icon from '../Common/Icon'

/**
 * One glyph per tab, in tab order. Shared by the docked strip and the collapsed
 * rail so a tab looks the same whichever of the two the user is reading.
 */
export const renderTabIcon = (tab: NotesPanelTab) => {
  switch (tab) {
    case NotesPanelTab.notes:
      return <Icon name="activity-bars" size="md" />
    case NotesPanelTab.flags:
      return <Icon name="flag-flat" size="md" />
    case NotesPanelTab.tasks:
      return <Icon name="check-circle" size="md" />
    case NotesPanelTab.marketIntel:
      return <Icon name="lightbulb" size="md" />
    case NotesPanelTab.news:
      return <Icon name="file-text" size="md" />
    case NotesPanelTab.logs:
      return <Icon name="audit-log" size="md" />
    default:
      return null
  }
}
